import { IRootState } from 'app/shared/reducers';
import { logOut } from 'app/shared/reducers/kubrick-management';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { gtmEvent } from '../gtm/service/gtm.service';



export const Logout = () => {

    const logoutDetails = useSelector((state: IRootState) => state.kubrickManagement.logoutDetails);
    const url = logoutDetails?.logoutUrl;
    const token = logoutDetails?.idToken;
    const loungeUrl = logoutDetails?.loungeUrl;
    const dispatch = useDispatch();

    useEffect(() => {
        if (url) {
            window.location.href = url.includes('/protocol')
                ? url + '?redirect_uri=' + loungeUrl
                : url + '?id_token_hint=' + token + '&post_logout_redirect_uri=' + loungeUrl;
        }
    }, [url]);

    useEffect(() => {
        dispatch(gtmEvent("Déconnexion", "Validé", '0'))
        dispatch(logOut());
    }, []);

    return (
        <div className="p-5">
        </div>
    );
};


